
export class Err extends Error {
	name = this.constructor.name
}

